import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "_mb-6 gfu-bt--b1" }
const _hoisted_2 = { class: "_fw-b _mb-3 _tc--dark gfu-bt--b1" }
const _hoisted_3 = { class: "_flexcol _gap-2" }
const _hoisted_4 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_title = _resolveComponent("base-title")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_box = _resolveComponent("box")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_base_title, {
      as: "h3",
      level: "h2"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.Resources.PledgeManager.SectionWalkthroughTitle), 1 /* TEXT */)
      ]),
      _: 1 /* STABLE */
    }),
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.Resources.PledgeManager.SectionWalkthroughDescription), 1 /* TEXT */),
    _createVNode(_component_box, { huge: "" }, {
      default: _withCtx(() => [
        _createElementVNode("p", _hoisted_2, _toDisplayString($props.description), 1 /* TEXT */),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.links, (link) => {
            return (_openBlock(), _createElementBlock("a", {
              key: link.label,
              href: link.url,
              target: "_blank",
              rel: "noopener noreferrer",
              class: "gfu-link gfu-link--accent gfu-bt--b1"
            }, [
              _createTextVNode(_toDisplayString(link.label) + " ", 1 /* TEXT */),
              _createVNode(_component_base_icon, { name: "chevron-right" })
            ], 8 /* PROPS */, _hoisted_4))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ]),
      _: 1 /* STABLE */
    })
  ]))
}